/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReferentialItemDto } from './ReferentialItemDto';
import {
    ReferentialItemDtoFromJSON,
    ReferentialItemDtoFromJSONTyped,
    ReferentialItemDtoToJSON,
    ReferentialItemDtoToJSONTyped,
} from './ReferentialItemDto';

/**
 * Support de souscription autorisé sur le tunnel.
 * @export
 * @interface SupportTunnelDto
 */
export interface SupportTunnelDto {
    /**
     * 
     * @type {string}
     * @memberof SupportTunnelDto
     */
    id: string;
    /**
     * 
     * @type {ReferentialItemDto}
     * @memberof SupportTunnelDto
     */
    typeSupport?: ReferentialItemDto;
    /**
     * 
     * @type {string}
     * @memberof SupportTunnelDto
     */
    typeSupportId?: string;
    /**
     * 
     * @type {number}
     * @memberof SupportTunnelDto
     */
    ordreAffichage?: number;
}

/**
 * Check if a given object implements the SupportTunnelDto interface.
 */
export function instanceOfSupportTunnelDto(value: object): value is SupportTunnelDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function SupportTunnelDtoFromJSON(json: any): SupportTunnelDto {
    return SupportTunnelDtoFromJSONTyped(json, false);
}

export function SupportTunnelDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupportTunnelDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'typeSupport': json['typeSupport'] == null ? undefined : ReferentialItemDtoFromJSON(json['typeSupport']),
        'typeSupportId': json['typeSupportId'] == null ? undefined : json['typeSupportId'],
        'ordreAffichage': json['ordreAffichage'] == null ? undefined : json['ordreAffichage'],
    };
}

export function SupportTunnelDtoToJSON(json: any): SupportTunnelDto {
    return SupportTunnelDtoToJSONTyped(json, false);
}

export function SupportTunnelDtoToJSONTyped(value?: SupportTunnelDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'typeSupport': ReferentialItemDtoToJSON(value['typeSupport']),
        'typeSupportId': value['typeSupportId'],
        'ordreAffichage': value['ordreAffichage'],
    };
}

